import ServiceExec from '@/common/utils/ServiceExec';
import dayjs from 'dayjs';
import { diary } from '@/common/service/apiList';
import store from '@/store';
import { convertToLocalDateTime } from '@/common/utils/module/FormattingSupport';

export default {
  fetchPickedDiaryList: async ({ commit, getters, rootGetters }) => {
    const user = rootGetters['user/getUserData'];
    const date = getters['date'];

    const condition = {
      pickedDate: dayjs(date).format('YYYY-MM-DD'),
      userNo: user.userNo
    };
    const { status, data } = await ServiceExec.get(diary.pickedList, condition);
    if (status !== ServiceExec.status.OK) return;

    commit('calendar', data);
  },

  fetchMonthEventList: async ({ commit, getters, rootGetters }) => {
    const user = rootGetters['user/getUserData'];
    const date = getters['date'];

    const condition = {
      pickedDate: dayjs(date).format('YYYY-MM-DD'),
      userNo: user.userNo
    };
    const { status, data } = await ServiceExec.get(diary.monthList, condition);
    if (status !== ServiceExec.status.OK) return;

    commit('monthCalendar', data);
  },

  fetchDetail: async ({ commit }, diaryNo) => {
    const { status, data } = await ServiceExec.get(diary.fetchDetail(diaryNo));
    if (status !== ServiceExec.status.OK) return;
    commit('setDetail', data);
  },

  save: async ({ commit, rootGetter }, payload) => {
    const user = store.getters['user/getUserData'];
    const request = { ...payload };
    request.userNo = user.userNo;
    request.date = convertToLocalDateTime(request.date);

    const response = await ServiceExec.post(diary.save, request);
    if (response.status !== ServiceExec.status.OK) return;
    return response.data;
  },

  delete: async ({ commit }, diaryNo) => {
    if (!diaryNo) return;
    const response = await ServiceExec.delete(diary.delete(diaryNo));
    if (response.status !== ServiceExec.status.OK) return;
    return response.data;
  }
};
